import { useState, useMemo, useEffect } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { CommonImages } from "../../../../reusableUI/images";
import { TbMessage2 } from "react-icons/tb";
import { IoSearchOutline } from "react-icons/io5";
import { FiFilter } from "react-icons/fi";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import {
  getSupport,
  updateSupport,
  updateSeen,
  updateStatus,
} from "../../../../Service/getSupport";
import Loader from "../../../../reusableUI/loader";
import CommonDropdown from "../../../../reusableUI/dropdown";
import Page from "../../../../reusableUI/page";
import moment from "moment";
import ReusableTable from "../../../../reusableUI/table";

const Support = () => {
  const [loading, setLoading] = useState(true);
  const [option, setOption] = useState("Complaint"); // "Complaint" | "Message"
  const [paginationPage, setPaginationPage] = useState(0);
  const [list, setList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState("All");
  const [selectedIssues, setSelectedIssues] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [responses, setResponses] = useState([]); // holds currently selected ticket (responses[0])
  const [selectedValue, setSelectedValue] = useState("open"); // status dropdown
  const [message, setMessage] = useState("");
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [unRead, setUnread] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(true);

  const navigate = useNavigate();

  const roleOptions = ["patient", "nurse"];
  const messageOptions = ["Unread", "Read"];

  const dateOptions = ["All", "Today", "Last 7 Days", "Last 30 Days"];
  const issueOptions = [
    "Appointment Issues",
    "Service Feedback",
    "Technical Support",
    "Billing And Payment",
  ];
  const issueOptions1 = [
    "Payment and Invoices",
    "Service Feedback",
    "Technical Support",
    "Shift Scheduling Issues",
  ];

  useEffect(() => {
    getSupportDetails();
  }, []);

  const getUnreadCount = (data) => {
    return data.reduce((total, item) => {
      const unReadCount = item.responses.filter(
        (response) => response?.seen === false && response?.who === "user"
      ).length;
      return total + unReadCount;
    }, 0);
  };

  const getSupportDetails = async () => {
    try {
      const res = await getSupport();
      if (res.error === false) {
        setList(res.data || []);
        setUnread(getUnreadCount(res.data || []));
      }
    } catch (e) {
      console.error("Error fetching support", e);
    } finally {
      setLoading(false);
    }
  };

  const updateMsgSeen = async (item) => {
    try {
      const data = {
        supportID: item._id,
        who: "user",
      };
      const update = await updateSeen(data);
      if (update.error === false) {
        const res = await getSupport();
        if (res.error === false) {
          setList(res.data || []);
          setUnread(getUnreadCount(res.data || []));
        }
      }
    } catch (e) {
      console.error("Error updating seen", e);
    }
  };

  const handleInputChange = (event) => {
    setMessage(event.target.value);
  };

  const handleDropdownChange = async (event, item) => {
    const newValue = event.target.value; // "open" | "escalated" | "closed"
    setSelectedValue(newValue);

    const data = {
      status: newValue,
      supportID: item._id,
      ticketNumber: item.ticketNumber,
    };

    try {
      const update = await updateStatus(data);
      if (update.error === false) {
        // keep chat in sync
        setResponses([update.data]);
      }
    } catch (e) {
      console.error("Error updating status", e);
    }
  };

  const options = [
    { label: "Open", value: "open" },
    { label: "Escalate", value: "escalated" },
    { label: "Close", value: "closed" },
  ];

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleDateChange = (option) => {
    setSelectedDateRange(option);
    setIsOpen(false);
  };

  const handleIssueChange = (issue) => {
    setSelectedIssues((prev) =>
      prev.includes(issue) ? prev.filter((i) => i !== issue) : [...prev, issue]
    );
  };

  const handleRoleChange = (role) => {
    setSelectedRoles((prevRoles) =>
      prevRoles.includes(role)
        ? prevRoles.filter((r) => r !== role)
        : [...prevRoles, role]
    );
  };

  const handleMessageFilterChange = (msg) => {
    setSelectedMessages((prev) =>
      prev.includes(msg)
        ? prev.filter((m) => m !== msg)
        : [...prev, msg]
    );
  };

  const onSelect = (optionValue) => {
    setOption(optionValue);
  };

  const handleChange2 = (event, value) => {
    setPaginationPage(value - 1);
  };

  const handleSender = async (ticket) => {
    const text = message.trim();
    if (!text) return;

    const data = {
      supportID: ticket._id,
      message: {
        who: "admin",
        dateTime: new Date(),
        message: text,
      },
    };

    try {
      const update = await updateSupport(data);
      if (update.error === false) {
        setResponses([update.data]); // updated conversation
        setMessage("");
      }
    } catch (e) {
      console.error("Error sending message", e);
    }
  };

  const getColumns = () => {
    const capitalizeFirstLetter = (string) => {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    return [
      {
        Header: "Name",
        accessor: "name",
        id: "name",
        width: 180,
        minWidth: 160,
        maxWidth: 220,
        disableSortBy: false,
        sortType: (rowA, rowB) => {
          const nameA = (rowA.original?.userName || "").toLowerCase();
          const nameB = (rowB.original?.userName || "").toLowerCase();
          return nameA.localeCompare(nameB);
        },
        headerStyle: {
          textAlign: "left",
          padding: "8px",
        },
        style: {
          textAlign: "left",
          padding: "8px",
        },
        Cell: ({ row: { original } }) => (
          <div className="flex items-center gap-2 whitespace-nowrap">
            <img
              src={
                original?.userID?.personalInfo?.basicInfo?.otherInfo?.gender ===
                  "male"
                  ? CommonImages.male
                  : CommonImages.female
              }
              alt="profile"
              className="h-6 w-6 rounded-full flex-shrink-0 object-cover"
            />
            <span
              className="text-[12px] truncate max-w-[120px]"
              title={original.userName || "N/A"}
            >
              {original.userName || "N/A"}
            </span>
          </div>
        ),
      },
      {
        Header: "Role",
        accessor: "role",
        id: "role",
        width: 100,
        minWidth: 90,
        maxWidth: 120,
        disableSortBy: false,
        sortType: (rowA, rowB) => {
          const roleA = (
            rowA.original?.userID?.role ||
            (rowA.original?.partnerID ? "Partner" : "")
          ).toLowerCase();
          const roleB = (
            rowB.original?.userID?.role ||
            (rowB.original?.partnerID ? "Partner" : "")
          ).toLowerCase();
          return roleA.localeCompare(roleB);
        },
        headerStyle: {
          textAlign: "center",
          padding: "8px",
        },
        style: {
          textAlign: "center",
          padding: "8px",
        },
        Cell: ({ row: { original } }) => (
          <span className="text-[12px]">
            {capitalizeFirstLetter(
              original?.userID?.role || (original?.partnerID ? "Partner" : "N/A")
            )}
          </span>
        ),
      },
      {
        Header: "Complaints",
        accessor: "complaints",
        id: "complaints",
        width: 380,
        minWidth: 320,
        maxWidth: 480,
        disableSortBy: false,
        sortType: (rowA, rowB) => {
          const titleA = (rowA.original?.title || "").toLowerCase();
          const titleB = (rowB.original?.title || "").toLowerCase();
          return titleA.localeCompare(titleB);
        },
        headerStyle: {
          textAlign: "left",
          padding: "8px",
        },
        style: {
          textAlign: "left",
          padding: "8px",
        },
        Cell: ({ row: { original } }) => (
          <div className="flex items-center bg-[#F7F8FA] p-2 rounded-md w-full">
            <p className="text-[#008BF8] font-semibold text-[12px] mr-2 flex-shrink-0 whitespace-nowrap">
              {original.title}:
            </p>
            <p
              className="text-[12px] flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
              title={original.description || "N/A"}
            >
              {original.description || "N/A"}
            </p>
          </div>
        ),
      },
      {
        Header: "Time",
        accessor: "time",
        id: "time",
        width: 160,
        minWidth: 140,
        maxWidth: 200,
        disableSortBy: false,
        sortType: (rowA, rowB) => {
          const dateA = new Date(rowA.original?.createdAt || 0).getTime();
          const dateB = new Date(rowB.original?.createdAt || 0).getTime();
          return dateA - dateB;
        },
        headerStyle: {
          textAlign: "center",
          padding: "8px",
        },
        style: {
          textAlign: "center",
          padding: "8px",
        },
        Cell: ({ row: { original } }) => (
          <span className="text-[12px] whitespace-nowrap">
            {moment(original.createdAt).format("MMM DD, YYYY - hh:mm A")}
          </span>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        id: "status",
        width: 90,
        minWidth: 80,
        maxWidth: 110,
        disableSortBy: false,
        sortType: (rowA, rowB) => {
          const order = { open: 1, escalated: 2, closed: 3 };
          const statusA = (rowA.original?.status || "").toLowerCase();
          const statusB = (rowB.original?.status || "").toLowerCase();
          return (order[statusA] || 0) - (order[statusB] || 0);
        },
        headerStyle: {
          textAlign: "center",
          padding: "8px",
        },
        style: {
          textAlign: "center",
          padding: "8px",
        },
        Cell: ({ row: { original } }) => {
          const status = (original.status || "").toLowerCase();
          let statusColor = "";

          switch (status) {
            case "escalated":
              statusColor = "text-yellow-500";
              break;
            case "closed":
              statusColor = "text-green-500";
              break;
            case "open":
              statusColor = "text-red-500";
              break;
            default:
              statusColor = "text-gray-500";
          }

          const cap = status.charAt(0).toUpperCase() + status.slice(1);

          return (
            <span className={`text-[12px] font-medium ${statusColor}`}>
              {cap || "N/A"}
            </span>
          );
        },
      },
      {
        Header: "Chat",
        accessor: "chat",
        id: "chat",
        width: 80,
        minWidth: 70,
        maxWidth: 100,
        disableSortBy: true,
        headerStyle: {
          textAlign: "center",
          padding: "8px",
        },
        style: {
          textAlign: "center",
          padding: "8px",
        },
        Cell: ({ row: { original } }) => (
          <button
            className="text-[12px] text-indigo-500 bg-indigo-50 hover:bg-indigo-100 hover:text-indigo-600 py-1.5 px-3 rounded-md cursor-pointer transition-colors font-medium"
            onClick={() => {
              setResponses([original]); // open this ticket in chat
              onSelect("Message");      // switch to Message tab
              updateMsgSeen(original);
            }}
          >
            View
          </button>
        ),
      },
    ];
  };

  const filteredData = useMemo(() => {
    if (!list) return [];
    let filteredList = [...list].reverse(); // newest last item first (if API is ascending)

    const now = moment();

    if (selectedDateRange === "Today") {
      filteredList = filteredList.filter((item) =>
        moment(item.updatedAt).isSame(now, "day")
      );
    } else if (selectedDateRange === "Last 7 Days") {
      filteredList = filteredList.filter((item) =>
        moment(item.updatedAt).isSameOrAfter(
          moment().subtract(7, "days"),
          "day"
        )
      );
    } else if (selectedDateRange === "Last 30 Days") {
      filteredList = filteredList.filter((item) =>
        moment(item.updatedAt).isSameOrAfter(
          moment().subtract(30, "days"),
          "day"
        )
      );
    }

    if (selectedIssues.length > 0) {
      filteredList = filteredList.filter((item) =>
        selectedIssues.includes(item.title)
      );
    }

    if (selectedRoles.length > 0) {
      filteredList = filteredList.filter((item) =>
        selectedRoles.includes(item?.userID?.role)
      );
    }

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      filteredList = filteredList.filter((item) =>
        item.userName?.toLowerCase().includes(q)
      );
    }

    if (selectedMessages.includes("Unread")) {
      filteredList = filteredList.filter((item) =>
        item.responses.some(
          (response) => response?.seen === false && response?.who === "user"
        )
      );
    } else if (selectedMessages.includes("Read")) {
      filteredList = filteredList.filter((item) =>
        item.responses.some(
          (response) => response?.seen === true && response?.who === "user"
        )
      );
    }

    return filteredList;
  }, [
    list,
    selectedDateRange,
    selectedIssues,
    selectedRoles,
    selectedMessages,
    searchQuery,
  ]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page: tablePage,
    prepareRow,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state: { pageIndex },
    gotoPage,
  } = useTable(
    {
      columns: useMemo(() => getColumns(), []),
      data: filteredData || [],
      initialState: { pageSize: 12 },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (pageIndex !== paginationPage) {
      setPaginationPage(pageIndex);
    }
  }, [pageIndex, paginationPage]);

  const handlePageChange = (page) => {
    gotoPage(page);
    setPaginationPage(page);
  };

  const navigateToProfile = (item) => {
    if (!item || !item.userID) {
      alert("Invalid item or missing user ID.");
      return;
    }

    localStorage.setItem("profilePage", "support");
    const profilePath = `/profile/${item.index || item._id}-${item._id}`;

    navigate(profilePath, {
      state: {
        userId: item.userID._id,
        from: window.location.pathname,
        currentPage: paginationPage,
        profilePage: "support",
      },
    });
  };

  const selectedThread = responses[0] || null;

  return (
    <>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <div className="bg-[#F3F6F5]">
          {/* Top toggle */}
          <div className="flex justify-around">
            <div
              className="flex-[0.5] p-1.5 h-10 rounded-xl shadow-md mx-1.5 mt-2.5 text-center flex justify-center items-center bg-white cursor-pointer"
              onClick={() => onSelect("Complaint")}
            >
              <p
                className={
                  option === "Complaint"
                    ? "text-indigo-500 text-[15px] font-semibold"
                    : "text-[14px] text-[#AAAAAB]"
                }
              >
                Complaint ({list.length})
              </p>
            </div>
            <div
              className="flex-[0.5] p-1.5 h-10 rounded-xl shadow-md mx-1.5 mt-2.5 mb-2 text-center flex justify-center items-center bg-white cursor-pointer"
              onClick={() => onSelect("Message")}
            >
              <div className="flex items-center">
                <TbMessage2
                  color={option === "Message" ? "#4850EB" : "#AAAAAB"}
                  style={{ marginRight: 5 }}
                  size={20}
                />
                <p
                  className={
                    option === "Message"
                      ? "text-indigo-500 text-[15px] font-semibold"
                      : "text-[14px] text-[#AAAAAB]"
                  }
                >
                  Message ({unRead})
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-2 m-2 h-[80vh]">
            {option === "Complaint" ? (
              <>
                {/* Complaint Table Header + Filter */}
                <div className="flex justify-between items-center">
                  <p className="text-[14px] ml-4 font-semibold">
                    Complaints list ({list.length})
                  </p>
                  <div className="relative inline-block text-left mr-4">
                    <button
                      onClick={toggleDropdown}
                      style={{ borderWidth: 1.5 }}
                      className="relative bg-white border border-blue-600 rounded-xl text-[14px] mb-3 text-blue-600 px-4 py-2"
                    >
                      <span className="mr-2 text-[12px]">
                        {selectedDateRange},{" "}
                        {selectedIssues[0] || "Select Issue"}
                      </span>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <svg
                          className="fill-current h-4 w-4"
                          viewBox="0 0 20 20"
                        >
                          <path d="M7 10l5 5 5-5H7z" />
                        </svg>
                      </div>
                    </button>

                    {isOpen && (
                      <div className="absolute mt-1 right-0 w-[220px] border border-[#4951EC] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20">
                        {/* Date Range */}
                        <div className="p-2">
                          {dateOptions.map((option) => (
                            <div
                              key={option}
                              className="flex items-center mb-1 cursor-pointer"
                            >
                              <input
                                type="radio"
                                id={option}
                                name="dateRange"
                                checked={selectedDateRange === option}
                                onChange={() => handleDateChange(option)}
                                className="mr-2 cursor-pointer"
                              />
                              <label
                                htmlFor={option}
                                className="text-[12px] cursor-pointer"
                              >
                                {option}
                              </label>
                            </div>
                          ))}
                        </div>

                        <hr />

                        {/* Role filter */}
                        <div className="p-2">
                          {roleOptions.map((role) => (
                            <div
                              key={role}
                              className="flex items-center mb-1 cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                id={role}
                                checked={selectedRoles.includes(role)}
                                onChange={() => handleRoleChange(role)}
                                className="mr-2 cursor-pointer"
                              />
                              <label
                                htmlFor={role}
                                className="text-[12px] cursor-pointer"
                              >
                                {role}
                              </label>
                            </div>
                          ))}
                        </div>

                        <hr />

                        {/* Issue filters */}
                        <div className="p-2">
                          {issueOptions.map((issue) => (
                            <div
                              key={issue}
                              className="flex items-center mb-1 cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                id={issue}
                                checked={selectedIssues.includes(issue)}
                                onChange={() => handleIssueChange(issue)}
                                className="mr-2 cursor-pointer"
                              />
                              <label
                                htmlFor={issue}
                                className="text-[12px] cursor-pointer"
                              >
                                {issue}
                              </label>
                            </div>
                          ))}
                        </div>

                        <hr />

                        <div className="p-2">
                          {issueOptions1.map((issue) => (
                            <div
                              key={issue}
                              className="flex items-center mb-1 cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                id={issue}
                                checked={selectedIssues.includes(issue)}
                                onChange={() => handleIssueChange(issue)}
                                className="mr-2 cursor-pointer"
                              />
                              <label
                                htmlFor={issue}
                                className="text-[12px] cursor-pointer"
                              >
                                {issue}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto max-h-[65vh] mt-[-5px]">
                  <div className="min-w-full w-full">
                    <ReusableTable
                      columns={getColumns}
                      getTableProps={getTableProps}
                      getTableBodyProps={getTableBodyProps}
                      headerGroups={headerGroups}
                      tablePage={tablePage}
                      prepareRow={prepareRow}
                      paginationPage={paginationPage}
                      nextPage={nextPage}
                      previousPage={previousPage}
                      canPreviousPage={canPreviousPage}
                      canNextPage={canNextPage}
                      pageOptions={pageOptions}
                      onPageChange={handlePageChange}
                      filterIcon={CommonImages.filter}
                      page={"support"}
                      drop={dropdownOpen}
                    />
                  </div>
                </div>

                {/* Pagination */}
                <div className="mb-2">
                  <Page
                    paginationPage={paginationPage}
                    nextPage={nextPage}
                    previousPage={previousPage}
                    canPreviousPage={canPreviousPage}
                    canNextPage={canNextPage}
                    pageOptions={pageOptions}
                    onPageChange={handleChange2}
                  />
                </div>
              </>
            ) : (
              // MESSAGE VIEW
              <div className="flex h-[75vh] bg-white">
                {/* LEFT: conversation list */}
                <div className="w-[40%] rounded-xl flex flex-col justify-start bg-white shadow-lg p-2">
                  {/* Search */}
                  <div
                    className="w-[95%] h-[6vh] border border-[#8D91E3] rounded-2xl mt-3 flex-row justify-between items-center self-center"
                    style={{ borderWidth: 1.5 }}
                  >
                    <div className="flex items-center flex-row justify-between p-2 mx-2">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="border-none ml-2.5 w-1/2 h-full focus:outline-none placeholder-small"
                        style={{
                          color: "black",
                          caretColor: "blue",
                        }}
                      />
                      <IoSearchOutline size={20} color={"#8D91E3"} />
                    </div>
                  </div>

                  {/* Filter trigger */}
                  <div
                    className="flex items-center self-end mr-3 mt-2 gap-1 mb-1 cursor-pointer"
                    onClick={toggleDropdown}
                  >
                    <FiFilter color={"#8D91E3"} size={16} />
                    <p className="text-[#8D91E3] text-[13px] font-semibold">
                      Filter
                    </p>
                  </div>

                  {/* Filter dropdown for message view */}
                  {isOpen && (
                    <div className="absolute mt-2 w-[220px] h-[60vh] rounded-md border border-[#4951EC] shadow-lg bg-white ring-1 ring-black ring-opacity-5 ml-40 z-30">
                      {/* Date */}
                      <div className="p-2">
                        {dateOptions.map((option) => (
                          <div
                            key={option}
                            className="flex items-center mb-1 cursor-pointer"
                          >
                            <input
                              type="radio"
                              id={option}
                              name="dateRange-msg"
                              checked={selectedDateRange === option}
                              onChange={() => handleDateChange(option)}
                              className="mr-2 cursor-pointer"
                            />
                            <label
                              htmlFor={option}
                              className="text-[12px] cursor-pointer"
                            >
                              {option}
                            </label>
                          </div>
                        ))}
                      </div>

                      <hr />

                      {/* Role */}
                      <div className="p-2">
                        {roleOptions.map((role) => (
                          <div
                            key={role}
                            className="flex items-center mb-1 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              id={`msg_${role}`}
                              checked={selectedRoles.includes(role)}
                              onChange={() => handleRoleChange(role)}
                              className="mr-2 cursor-pointer"
                            />
                            <label
                              htmlFor={`msg_${role}`}
                              className="text-[12px] cursor-pointer"
                            >
                              {role}
                            </label>
                          </div>
                        ))}
                      </div>

                      <hr />

                      {/* Issues */}
                      <div className="p-2">
                        {issueOptions.map((issue) => (
                          <div
                            key={issue}
                            className="flex items-center mb-1 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              id={`msg_${issue}`}
                              checked={selectedIssues.includes(issue)}
                              onChange={() => handleIssueChange(issue)}
                              className="mr-2 cursor-pointer"
                            />
                            <label
                              htmlFor={`msg_${issue}`}
                              className="text-[12px] cursor-pointer"
                            >
                              {issue}
                            </label>
                          </div>
                        ))}
                      </div>

                      <hr />

                      <div className="p-2">
                        {issueOptions1.map((issue) => (
                          <div
                            key={issue}
                            className="flex items-center mb-1 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              id={`msg2_${issue}`}
                              checked={selectedIssues.includes(issue)}
                              onChange={() => handleIssueChange(issue)}
                              className="mr-2 cursor-pointer"
                            />
                            <label
                              htmlFor={`msg2_${issue}`}
                              className="text-[12px] cursor-pointer"
                            >
                              {issue}
                            </label>
                          </div>
                        ))}
                      </div>

                      <hr />

                      {/* Message Read/Unread */}
                      <div className="p-2">
                        {messageOptions.map((msg) => (
                          <div
                            key={msg}
                            className="flex items-center mb-1 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              id={`filter_${msg}`}
                              checked={selectedMessages.includes(msg)}
                              onChange={() => handleMessageFilterChange(msg)}
                              className="mr-2 cursor-pointer"
                            />
                            <label
                              htmlFor={`filter_${msg}`}
                              className="text-[12px] cursor-pointer"
                            >
                              {msg}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Conversation list */}
                  <div className="overflow-y-auto overflow-x-hidden min-h-[60vh] pr-2 mt-1">
                    {filteredData.length > 0 ? (
                      filteredData.map((item, index) => {
                        const unReadCount = item?.responses.filter(
                          (response) =>
                            response?.seen === false && response?.who === "user"
                        ).length;

                        return (
                          <div
                            key={item._id || index}
                            className={`cursor-pointer rounded-md border border-[#E7E7EC] mx-auto mb-1.5 flex items-center justify-between w-full ${selectedCardId === index
                              ? "bg-[#F7F8FA]"
                              : "bg-white"
                              }`}
                            onClick={() => {
                              setSelectedCardId(index);
                              setResponses([item]);
                              if (unReadCount > 0) {
                                updateMsgSeen(item);
                              }
                            }}
                          >
                            <div
                              className={`mx-3 flex-1 ${selectedCardId === index
                                ? "bg-[#F7F8FA]"
                                : "bg-white"
                                }`}
                            >
                              <div className="flex items-center">
                                <img
                                  src={
                                    item?.userID?.personalInfo?.basicInfo
                                      ?.otherInfo?.gender === "male"
                                      ? CommonImages.male
                                      : CommonImages.female
                                  }
                                  alt="profile"
                                  className="h-10 w-10 rounded-full mr-2 my-1"
                                />
                                <div className="flex flex-col">
                                  <p className="text-[12px] font-bold mb-1 truncate max-w-[200px]">
                                    {item.userName}
                                  </p>
                                  <div className="flex flex-row max-w-[250px] items-center space-x-1">
                                    <p className="text-[#008BF8] text-[12px] uppercase max-w-[150px] truncate">
                                      {item.title}:
                                    </p>
                                    <p className="text-[12px] truncate">
                                      {item.description
                                        ? item.description.slice(0, 60)
                                        : "N/A"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Time + unread badge */}
                            <div className="flex flex-col items-end mr-2 mt-[-20px]">
                              <p className="text-[10px] text-[#008BF8] self-start">
                                {moment(item.createdAt).format(
                                  "DD-MMM hh:mm A"
                                )}
                              </p>
                              {unReadCount > 0 && (
                                <div className="bg-[#4951EC] rounded-full flex justify-center items-center w-3 h-3">
                                  <p className="text-white text-[8px]">
                                    {unReadCount}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="w-full h-full flex justify-center items-center">
                        <p className="text-[12px] text-gray-500">
                          No conversations found
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* RIGHT: chat panel */}
                <div className="flex-1 h-[75vh] flex flex-col justify-start ml-3">
                  {selectedThread ? (
                    <>
                      {/* Chat header */}
                      <div className="flex justify-between items-center bg-white border border-[#EBF2F5] rounded-md shadow-md mr-3 ml-2 w-[98%] mb-2">
                        <div className="flex items-center">
                          <img
                            src={
                              selectedThread?.userID?.personalInfo?.basicInfo
                                ?.otherInfo?.gender === "male"
                                ? CommonImages.male
                                : CommonImages.female
                            }
                            alt="profile"
                            className="h-10 w-10 rounded-full ml-5 my-1"
                          />
                          <p className="ml-2 font-semibold">
                            {selectedThread.userName}
                          </p>

                          <div onClick={() => navigateToProfile(selectedThread)}>
                            <AiOutlineExclamationCircle
                              color={"#4951EC"}
                              size={16}
                              className="ml-4 cursor-pointer"
                            />
                          </div>
                        </div>
                        <div className="mr-2">
                          <CommonDropdown
                            options={options}
                            value={selectedValue}
                            onChange={(event) =>
                              handleDropdownChange(event, selectedThread)
                            }
                            custum={{
                              backgroundColor:
                                selectedValue === "open"
                                  ? "#504EFF17"
                                  : selectedValue === "escalated"
                                    ? "#E2AF1A1A"
                                    : selectedValue === "closed"
                                      ? "#38AF651A"
                                      : "#fff",
                              borderColor:
                                selectedValue === "open"
                                  ? "#504EFF17"
                                  : selectedValue === "escalated"
                                    ? "#E2AF1A1A"
                                    : selectedValue === "closed"
                                      ? "#38AF651A"
                                      : "blue",
                            }}
                            text={{
                              color:
                                selectedValue === "open"
                                  ? "#504EFF"
                                  : selectedValue === "escalated"
                                    ? "#E2AF1A"
                                    : selectedValue === "closed"
                                      ? "#38AF65"
                                      : "blue",
                            }}
                          />
                        </div>
                      </div>

                      {/* Messages area */}
                      <div className="flex-1 bg-[#F7F8FA] rounded-[15px] shadow-lg ml-2 w-[98%] overflow-y-auto overflow-x-hidden">
                        <div className="ml-2 w-full py-2">
                          {selectedThread.responses?.map((msg, index) => (
                            <div key={index} className="flex flex-col mb-2">
                              <div
                                className={`flex flex-row ${msg?.who === "user"
                                  ? "self-start ml-1 mt-3"
                                  : "self-end pl-3 mt-3"
                                  }`}
                              >
                                {msg?.who === "user" && (
                                  <img
                                    src={
                                      selectedThread?.userID?.personalInfo
                                        ?.basicInfo?.otherInfo?.gender ===
                                        "male"
                                        ? CommonImages.male
                                        : CommonImages.female
                                    }
                                    alt="User"
                                    className="h-6 w-6 ml-4 rounded-full"
                                  />
                                )}

                                <div
                                  className={`flex-col bg-white p-2 m-2 rounded-md shadow-md max-w-sm ${msg?.who === "user"
                                    ? "self-start ml-2"
                                    : "self-end mr-2"
                                    }`}
                                >
                                  {msg?.title && (
                                    <div
                                      className={`${msg?.who === "user"
                                        ? "bg-[#4951EC]"
                                        : "bg-gray-100"
                                        } p-2 rounded-md`}
                                    >
                                      {msg?.who === "user" && (
                                        <p className="text-[12px] text-white">
                                          {msg?.title}
                                        </p>
                                      )}
                                    </div>
                                  )}

                                  {msg?.who === "user" ? (
                                    <div className="flex items-center mt-1">
                                      <p className="text-[12px] w-[80%] mt-1">
                                        {msg?.message}
                                      </p>
                                      <p className="text-[10px] text-[#008BF8] text-right w-[200px] mt-1">
                                        {moment(msg?.dateTime).format(
                                          "MMM DD, YYYY hh:mm A"
                                        )}
                                      </p>
                                    </div>
                                  ) : (
                                    <div>
                                      <p className="text-[12px] w-[80%] mb-2 mt-1">
                                        {msg?.message}
                                      </p>
                                      <p className="text-[10px] text-[#008BF8] text-right">
                                        {moment(msg?.dateTime).format(
                                          "MMM DD, YYYY hh:mm A"
                                        )}
                                      </p>
                                    </div>
                                  )}
                                </div>

                                {msg?.who === "admin" && (
                                  <img
                                    src={CommonImages.emptyLogo}
                                    alt="Admin"
                                    className="h-6 w-6 mt-2"
                                  />
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Input area */}
                      <div className="flex flex-row items-end gap-2 border border-[#C3CCD1] rounded-xl p-1 mx-4 ml-2 mt-3 bg-white">
                        <textarea
                          placeholder="Type your message here..."
                          className="flex-1 resize-none border-none focus:outline-none placeholder:text-gray-400 placeholder:text-[13px] text-[14px] leading-relaxed py-2 px-2 max-h-32 min-h-[40px]"
                          value={message}
                          onChange={handleInputChange}
                          onInput={(e) => {
                            e.target.style.height = "auto";
                            e.target.style.height = `${Math.min(
                              e.target.scrollHeight,
                              128
                            )}px`;
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              handleSender(selectedThread);
                            }
                          }}
                          rows={1}
                          style={{
                            color: "black",
                            caretColor: "#4951EC",
                            overflow: "hidden",
                          }}
                        />
                        <button
                          onClick={() => handleSender(selectedThread)}
                          className="flex-shrink-0 p-2 hover:bg-blue-50 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                          disabled={!message.trim()}
                        >
                          <img
                            src={CommonImages.sender}
                            className="h-6 w-6"
                            alt="Send"
                          />
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="w-full h-full flex justify-center items-center">
                      <p className="text-[14px] text-gray-500">
                        No chat selected
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Support;